<template>
    <div class="col-sm-12">
        <h4 class="heading">Fees &amp; Charges</h4><hr>
        <div class="row">
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.commission_value')}">
                <label>Commission<span > : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.commission_value') }}</span>
                <span >{{Number((formInput.commission_value).toFixed(2)).toLocaleString('ja-JP')}}&nbsp;({{formInput.commission_rate+' '+(formInput.commission_type=='0'?'%':(formInput.commission_type=='2'?'Per Qty':(formData.currency||formData.stock.currency)))}})</span>
                <div v-if="formData.action!='view'" class="input-group"> 
                    <select class="form-control w-40" v-model="formInput.commission_type">
                        <option value="0">Percentage</option>
                        <option value="1">Fixed Value</option>
                        <option value="2">Value Per Quantity</option>
                    </select>
                    <input type="number" v-model="formInput.commission_rate" min="0" class="form-control w-60"/>
                </div>
            </div>
            <div v-if="can_access('deal_second_step_before_approval','modify')" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stamp_duty_value')}">
                <label>Stamp Duty<span> : &nbsp;&nbsp;</span><span v-if="formData.stamp_duty_exemption" style="color:green"> (Exemption Available)</span></label><span class="message">{{ validation.firstError('formInput.stamp_duty_value') }}</span>
                <span v-if="!formData.stamp_duty_exemption">{{Number((formInput.stamp_duty_value).toFixed(2)).toLocaleString('ja-JP')}} ({{formInput.stamp_duty_rate+' '+(formInput.stamp_duty_type=='0'?'%':(formInput.stamp_duty_type=='2'?'Per Qty':(formData.currency||formData.stock.currency)))}})</span>
                <div v-if="formData.action!='view'" class="input-group"> 
                    <select class="form-control w-40" v-model="formInput.stamp_duty_type">
                        <option value="0">Percentage</option>
                        <option value="1">Fixed Value</option>
                        <option value="2">Value Per Quantity</option>
                    </select>
                    <input type="number" v-model="formInput.stamp_duty_rate" min="0" class="form-control w-60"/>
                </div>
            </div>
            <div v-if="can_access('deal_second_step_before_approval','modify')" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.fees_value')}">
                <label>Fees<span> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.fees_value') }}</span>
                <span>{{Number((formInput.fees_value).toFixed(2)).toLocaleString('ja-JP')}} ({{formInput.fees_rate+' '+(formInput.fees_type=='0'?'%':(formInput.fees_type=='2'?'Per Qty':(formData.currency||formData.stock.currency)))}})</span>
                <div v-if="formData.action!='view'" class="input-group"> 
                    <select class="form-control w-40" v-model="formInput.fees_type">
                        <option value="0">Percentage</option>
                        <option value="1">Fixed Value</option>
                        <option value="2">Value Per Quantity</option>
                    </select>
                    <input type="number" v-model="formInput.fees_rate" min="0" class="form-control w-60"/>
                </div>
            </div>
            <div v-if="can_access('deal_second_step_before_approval','modify')" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.other_levy_value')}">
                <label>Other Levy<span> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.other_levy_value') }}</span>
                <span>{{Number((formInput.other_levy_value).toFixed(2)).toLocaleString('ja-JP')}} ({{formInput.other_levy_rate+' '+(formInput.other_levy_type=='0'?'%':(formInput.other_levy_type=='2'?'Per Qty':(formData.currency||formData.stock.currency)))}})</span>
                <div v-if="formData.action!='view'" class="input-group"> 
                    <select class="form-control w-40" v-model="formInput.other_levy_type">
                        <option value="0">Percentage</option>
                        <option value="1">Fixed Value</option>
                        <option value="2">Value Per Quantity</option>
                    </select>
                    <input type="number" v-model="formInput.other_levy_rate" min="0" class="form-control w-60"/>
                </div>
            </div>
            <div v-if="can_access('deal_second_step_before_approval','modify')" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.other_taxes_value')}">
                <label>Other Taxes<span> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.other_taxes_value') }}</span>
                <span>{{Number((formInput.other_taxes_value).toFixed(2)).toLocaleString('ja-JP')}} ({{formInput.other_taxes_rate+' '+(formInput.other_taxes_type=='0'?'%':(formInput.other_taxes_type=='2'?'Per Qty':(formData.currency||formData.stock.currency)))}})</span>
                <div v-if="formData.action!='view'" class="input-group"> 
                    <select class="form-control w-40" v-model="formInput.other_taxes_type">
                        <option value="0">Percentage</option>
                        <option value="1">Fixed Value</option>
                        <option value="2">Value Per Quantity</option>
                    </select>
                    <input type="number" v-model="formInput.other_taxes_rate" min="0" class="form-control w-60"/>
                </div>
            </div>
            <div v-if="can_access('deal_second_step_before_approval','modify')" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.other_fees_and_charges_value')}">
                <label>Other Fees &amp; Charges<span> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.other_fees_and_charges_value') }}</span>
                <span>{{Number((formInput.other_fees_and_charges_value).toFixed(2)).toLocaleString('ja-JP')}} ({{formInput.other_fees_and_charges_rate+' '+(formInput.other_fees_and_charges_type=='0'?'%':(formInput.other_fees_and_charges_type=='2'?'Per Qty':(formData.currency||formData.stock.currency)))}})</span>
                <div v-if="formData.action!='view'" class="input-group"> 
                    <select class="form-control w-40" v-model="formInput.other_fees_and_charges_type">
                        <option value="0">Percentage</option>
                        <option value="1">Fixed Value</option>
                        <option value="2">Value Per Quantity</option>
                    </select>
                    <input type="number" v-model="formInput.other_fees_and_charges_rate" min="0" class="form-control w-60"/>
                </div>
            </div>
            <div v-if="can_access('deal_second_step_before_approval','modify')" :class="bulk?'col-sm-3':'col-sm-4'" class="form-group form-check mt-3">
                <input v-if="formData.action!=1" type="checkbox" :readonly="formData.action=='view'" :disabled="formData.action=='view'" class="form-check-input" v-model="formInput.exchange_fee"/>
                <label class="bold form-check-label" style="color:black">PTM Levy</label>
                <!-- <span v-if="formData.action=='view'" class="bold">{{formInput.exchange_fee}}</span> -->
            </div>
            <div v-if="can_access('deal_second_step_before_approval','modify') && bulk" class="col-sm-3 form-group mt-3">
                <label class="bold">Trade Value<span> : &nbsp;&nbsp;</span></label>
                <span class="bold">{{Number((formData.trade_price * formData.account_detail[index].quantity).toFixed(2)).toLocaleString('ja-JP')}}</span>
            </div>
            <div v-if="can_access('deal_second_step_before_approval','modify')" :class="bulk?'col-sm-3':'col-sm-4'" class="form-group mt-3">
                <label class="bold">Total Charges<span> : &nbsp;&nbsp;</span></label>
                <span class="bold">{{Number(total_other_charges.toFixed(2)).toLocaleString('ja-JP')}}</span>
            </div>
            <div v-if="can_access('deal_second_step_before_approval','modify')" :class="bulk?'col-sm-3':'col-sm-4'" class="form-group mt-3">
                <label class="bold">Total Consideration<span> : &nbsp;&nbsp;</span></label>
                <span class="bold">{{Number(total_consideration.toFixed(2)).toLocaleString('ja-JP')}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import SimpleVueValidator from 'simple-vue-validator';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import 'vue-material/dist/vue-material.css';
import common from '@/assets/js/common.js';

const Validator = SimpleVueValidator.Validator;
export default {
    name: "AddBulkCustomer",
    props: ['row','index','formData','bulk'],
    mixins: [common, SimpleVueValidator.mixin],
    components: {VueBootstrapTypeahead},
    data(){
        return {
          formInput:{
            commission_rate : 1,
            commission_value : '',
            commission_type: '0',
            stamp_duty_rate: 0,
            stamp_duty_value: '',
            stamp_duty_type: '0',
            fees_rate : 0,
            fees_value : '',
            fees_type : '0',
            other_levy_rate : 0,
            other_levy_value : '',
            other_levy_type : '0',
            other_taxes_rate : 0,
            other_taxes_value : '',
            other_taxes_type : '0',
            other_fees_and_charges_rate : 0,
            other_fees_and_charges_value : '',
            other_fees_and_charges_type : '0',
            exchange_fee : 0,
          },
          total_other_charges : 0,
          total_consideration: 0
        };
    },
    validators: {
    },
    created(){
        if(this.action != 'view'){
            this.stampDutyExemptionChecker();
            this.exchangeFee();
        }
        if(typeof this.row != 'undefined'){
            Object.assign(this.formInput, this.row);
        }
        this.calc_value();
        //console.log(this.row,this.formInput);
    },
    mounted(){
        if(this.action == 'view'){
            var el = this.$el.getElementsByTagName("label");
            for (var i = 0; i<el.length; i++) {
                el[i].style.fontWeight = 600;
            }
        }
    },
    watch: {
      formInput : {
        handler:function(value) {
          if(value.exchange_fee) this.formInput.exchange_fee = 1;
          else this.formInput.exchange_fee = 0;
          this.calc_value()
          this.$emit('feesAndCharges',value)
        },
        deep : true,
      },
      'formData.stock': {
          handler:function(value) {
          this.exchangeFee()
          this.stampDutyExemptionChecker();
        },
        deep : true,
      },
      'formData.type': function(value){
          this.exchangeFee()
          this.stampDutyExemptionChecker();
      },
      'formData.trade_date': function(value){
        this.exchangeFee()
        this.stampDutyExemptionChecker();
      },
      'formData.capacity': function(value) {
          //this.stampDutyExemptionChecker();
          this.exchangeFee()
      },
      'formData.total_quantity': function(value) {
          //this.stampDutyExemptionChecker();
          this.exchangeFee()
          this.calc_value()
      },
      'formData.trade_price': function(value) {
          //this.stampDutyExemptionChecker();
          this.exchangeFee()
          this.calc_value()
      },
    },
    methods: {
        stampDutyExemptionChecker(){
            /* if(((!this.formInput.stock.stamp_duty_exemption_start_date || moment(this.formInput.trade_date,'DD-MM-YYYY').isSameOrAfter(moment(this.formInput.stock.stamp_duty_exemption_start_date,'DD-MM-YYYY'))) && (!this.formInput.stock.stamp_duty_exemption_end_date || moment(this.formInput.trade_date,'DD-MM-YYYY').isSameOrBefore(moment(this.formInput.stock.stamp_duty_exemption_end_date,'DD-MM-YYYY')))) && (this.formInput.stock.stamp_duty_exemption_start_date || this.formInput.stock.stamp_duty_exemption_end_date)) this.formInput.stamp_duty_exemption = 1;
            else this.formInput.stamp_duty_exemption = 0;

            this.calc_value(); */
            if(this.formData.stamp_duty_exemption) this.formInput['stamp_duty_rate'] = 0;
            else if(["BUY"].indexOf(this.formData.type) >= 0 && (this.formData.stock.isin.substring(0, 2).toUpperCase() == 'GB') && this.formData.stock.currency == 'GBP') this.formInput['stamp_duty_rate'] = 0.5;
            else this.formInput['stamp_duty_rate'] = 0;

            if(this.formData.type.search(/charges|deposit|withdrawal|fees|dividends|fx/i) >= 0) this.formInput['commission_rate'] = 0;
            else  this.formInput['commission_rate'] = 1;
        },
        exchangeFee(){
            if(this.formData.action!='view'){
                var quantity = ((Object.keys(this.formData.account_detail).length>1 || this.formData.account_detail[this.index].quantity)?this.formData.account_detail[this.index].quantity:this.formData.total_quantity);
                var trade_value = (quantity*this.formData.trade_price);

                this.formInput.exchange_fee = (['DEAL','AOTC'/* ,'GIVEIN' */].indexOf(this.formData.capacity) >= 0 && trade_value >= 10000 && (this.formData.stock.currency == 'GBP' /* || this.formData.currency */) && (["BUY","SELL"/* ,"FOP IN","FOP OUT","TRANSFER IN","TRANSFER OUT",'GIVE IN','GIVE UP','DVP IN','DVP OUT' */].indexOf(this.formData.type) >= 0)) ? 1 : 0;
            }
        },
        calc_value: function(){
            //console.log(this.formInput, this.formData);
            var quantity = ((Object.keys(this.formData.account_detail).length>1 || this.formData.account_detail[this.index].quantity)?this.formData.account_detail[this.index].quantity:this.formData.total_quantity);
            var trade_value = (quantity*this.formData.trade_price);
            this.total_other_charges = 0;
            ['commission','stamp_duty','fees','other_levy','other_taxes','other_fees_and_charges'].forEach((val,i) => {
                if(!this.can_access('stamp_duty_rate','modify') && val == 'stamp_duty' && this.formData.stamp_duty_exemption) this.formInput['stamp_duty_rate'] = 0;
                /* else if(val == 'stamp_duty' && this.formData.stock.currency=='GBP') this.formInput['stamp_duty_rate'] = 0.5;
                else if(val == 'stamp_duty') this.formInput['stamp_duty_rate'] = 0; */

                if(this.formInput[val+'_type'] == 0){
                    //if(this.formInput[val+'_rate'] > 5) this.formInput[val+'_rate'] = 5;
                    /* else */ if(this.formInput[val+'_rate'] < 0) this.formInput[val+'_rate'] = 0;
                    this.formInput[val+'_value'] = this.formatNumber(parseFloat(this.formInput[val+'_rate'] * (trade_value/100)));
                }

                else if(this.formInput[val+'_type'] == 1 /* && this.formInput[val+'_rate'] <= 30 */ && this.formInput[val+'_rate'] >= 0) this.formInput[val+'_value'] = parseFloat(this.formInput[val+'_rate']);

                else if(this.formInput[val+'_type'] == 2 /* && this.formInput[val+'_rate'] <= 30 */ && this.formInput[val+'_rate'] >= 0) this.formInput[val+'_value'] = parseFloat(this.formInput[val+'_rate'] * quantity);

                else if(this.formInput[val+'_rate'] < 0) this.formInput[val+'_rate'] = 0;
                else{
                this.formInput[val+'_value'] = 0;
                //this.formInput[val+'_rate'] = 30;
                }

                this.total_other_charges += this.formInput[val+'_value'];
            });

            this.total_other_charges += parseFloat(this.formInput.exchange_fee);
            if(this.formData.type.search(/buy|fop in|transfer in|give in|dvp in|withdrawal|charges|fees/i) >= 0) this.total_consideration = trade_value + this.total_other_charges;
            else this.total_consideration = parseFloat(trade_value) - parseFloat(this.total_other_charges);
        },
    }
}
</script>
<style scoped>
.form-check-label{
  padding-left: 5px !important;
  vertical-align: middle;
  /* vertical-align: -moz-middle-with-baseline; */
}
.form-check{
  padding-left: 30px !important;
}
</style>